import { useQuery } from "@tanstack/react-query";
import { Space } from "antd";
import { fetchFormConfigurations } from "../../../lib/api/resources/formConfigurations";
import { formConfigurationsColumns } from "./constants/formConfigurationColumns";
import { Table } from "@/components/v2";
import { useUrlPagination } from "@/pages/admin/dossiers/lib/urlState/useUrlPagination.ts";

export const FormConfigurationsList = () => {
  const { value: page, setValue: setPage } = useUrlPagination({
    param: "page",
  });
  const formConfigurationsQuery = useQuery({
    queryKey: ["formConfigurations", page],
    queryFn: () => fetchFormConfigurations({ page }),
  });

  return (
    <div>
      <Space
        style={{ marginBottom: 16, width: "100%", justifyContent: "flex-end" }}
      ></Space>
      <Table
        columns={formConfigurationsColumns}
        pagination={{
          pageSize: 15,
          total: formConfigurationsQuery.data?.totalItems,
          showSizeChanger: false,
          onChange: (page) => setPage(page),
        }}
        dataSource={formConfigurationsQuery.data?.member}
        loading={formConfigurationsQuery.isLoading}
      />
    </div>
  );
};
